import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { BaseBarcode } from '../../controls/BaseBarcode';
import { EardrumOptions } from './EardrumOptions';
import { EardrumCustomerInfo } from './EardrumCustomerInfo';
import  WsaLogo from '../../Images/WSA.png';
import toLocalString from '../../infrastructure/DateTimeFunctions';

export class OtherEarmoldView extends Component {   
    constructor(props) {
        super(props);                
    }
    renderRemark() {
        //let printMode = this.props.printMode;
        //console.log(this.props.printMode);
        //if (printMode === true) {
        //    return null;
        //}
        return (<label className="no-print text-xs ml-4 text-red-500">{this.props.remark}</label>);
    }
    parseEarmoldVersion(version) {
        let vString = "";
        if (version) {
            let arr = version.split(',');
            if (arr.length == 2) {
                vString = arr[0] + '-' + arr[1];
            }
        }
       
        return vString;
    }

    parseGetVersionCode(version) {
        let vString = "";
        if (version) {
            let arr = version.split(',');
            if (arr.length == 2) {
                return arr[1];
            }
        }
       
        return vString;
    }

    render() {
        let data = this.props.model;        
        if (!data) {
            return null;
        }
        
        let classNameValue = "bg-white overflow-hidden sm:rounded-sm text-xs h-full";
        if (this.props.printing || this.props.printMode) {
            classNameValue = "bg-white sm:rounded-sm text-xs h-full transform scale-y-84 origin-top inline-block";
        }

        return (
            <div id="pEarmoldDiv" className={classNameValue}>
                <div className="w-full">
                    <form>
                        <div className="px-8 py-6" id="orderForm" style={{ pointerEvents: "none" }}>
                            <div className="w-full overflow-hidden">
                                <div className="grid grid-cols-3">
                                    <div className="text-sm flex items-center">
                                        <BaseBarcode value={data.orderNum} />
                                        {this.renderRemark()}
                                    </div>
                                    <div className="text-center leading-6">
                                        <div className="text-2xl font-bold">
                                            <span className="text-purple-600 mr-2">WSA</span><span className="text-gray-500"><FormattedMessage id="EardrumOrderTitle" />{data.dealerInfo.isOtherPlatform && <span className="text-sm text-red-500">（<FormattedMessage id="TingzhanOrder" />）</span>}</span>
                                        </div>
                                        <span className="text-gray-700 text-xs font-bold"><FormattedMessage id="Earmold" />{this.parseEarmoldVersion(data.eardrumInfo.earmoldVersion)}</span>
                                    </div>

                                    <div className="flex justify-between">
                                        <div className="w-44">
                                            <div className="bg-gray-900 text-white px-2 font-bold"><FormattedMessage id="InfoOrderNum" /></div>
                                            <div className="bg-gray-200 h-8 px-1 pt-1 text-sm">{data.infoId}</div>
                                        </div>
                                        <div><img className="mt-2" src={WsaLogo} /></div>
                                    </div>
                                </div>

                            </div>
                            <EardrumCustomerInfo model={data.eardrumCustomerInfo} dealerInfo={data.dealerInfo} printing={this.props.printing} printMode={this.props.printMode}/>
                            <EardrumOptions model={data.eardrumInfo}  printMode={this.props.printMode} fillingPerson={data.fillingPerson} contactDetails={data.contactDetails} orderTime={data.orderTime ? toLocalString(data.orderTime, true) : ""} ></EardrumOptions>
                        </div>


                    </form>
                </div>
            </div>
        );

    }

}
